<!--
    LISTAGEM DE CLIENTES DO APP DE PEDIDOS
-->

<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import CustomerForm from '../forms/customer-form'
import { SysVars } from '../main';
import { objectToCsv, downloadCsvReport } from '../shared/csvReport'

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            codpart: '',
            metadata: this.$store.getters.getEntities.metadata,
            offset: false,
            moreActionsBarList: [
                { action: 0, label: 'Importar Clientes' },
            ]
        }
    },

    computed: {
        nextPage: function () {
            return this.$store.getters.getNextPage
        },

        partList: function () {
            return this.$store.getters.getPartList
        },

        controleLimiteCredito: function () {
            return true
        },
    },

    methods: {
        async handleAction(act) {
            if (act == 0) {
                //importação de cadastro de clientes
                this.$router.push('/importa/clientes')
            }
            if (act == 'xls') {
                while (this.nextPage){
                  await this.handleMore(true);
                }

                const data = this.partList
                .map(it => {
                    let obj = {
                                codigo: it.codpart,
                                nome: it.nome,
                                fantasia: it.fantasia,
                                cnpjcpf: it.cnpjcpf,
                                cidade: it.nomemun,
                                uf: it.uf,
                                email: it.email,
                                st: it.stpart,
                    }
                    if (it.cnpjcpf)
                      obj.cnpjcpf = it.cnpjcpf.toString()
                    else
                      obj.cnpjcpf = ''
                    if (it.fone1)
                      obj.fone1 = it.fone1.toString()
                    else
                      obj.fone1 = ''
                    if (it.fone2)
                      obj.fone2 = it.fone2.toString()
                    else
                      obj.fone2 = ''
                    if (it.fone3)
                      obj.fone3 = it.fone3.toString()
                    else
                      obj.fone3 = ''

                    if (!obj.email)
                      obj.email = ''

                    return obj
                })
                if (!data || data.length == 0)
                    this.$erpToastError('Nenhum cliente para visualizar')
                else {
                    const csv = objectToCsv(data)
                    downloadCsvReport(csv)
                }
            }
        },

        editPart (codpart) {
            //abre a tela de edicao
            this.crud = SysVars.crudU //update
            this.codpart = codpart
            this.showForm = true;
            this.$modalForm(true);
        },

        incluirPart (codpart) {
            //abre a tela de edicao
            this.crud = SysVars.crudI
            this.codpart = codpart
            this.showForm = true;
            this.$modalForm(true);
        },

        handlePainel (codpart) {
          this.$router.push('/fv/clientes/painel/' + codpart)
        },

        onAction (action) {

        },

        closeForm () {
            this.showForm = false
            this.$modalForm(false)
            this.loadData()
        },

        search (value) {
            this.filter = '{"$or":[{"nome":{"$like":"%25' + value + '%25"}},{"fantasia":{"$like":"%25' + value + '%25"}},{"codpart":{"$eq":"' + value + '"}},{"cnpjcpf":{"$eq":"' + value + '"}}]}'
            this.loadData()
        },

        async loadData (wait) {
            let params = { filter: this.filter }

            if (this.offset) {
                params.offset = this.nextPage
            }

            if (wait){
              await this.$store.dispatch('loadClientesFv', params )
            }else{
              this.$store.dispatch('loadClientesFv', params )
            }

            this.offset = false


        },

        async handleMore (wait) {
            this.offset = true
            await this.loadData(wait)
        },

        scroll () {
          window.onscroll = () => {
            if (this.offset || this.nextPage == 0)
              return
            let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= (document.documentElement.offsetHeight - 2)

            if (bottomOfWindow && !this.showForm) {
              this.offset = true
              this.loadData()
            }
            SysVars.scrollPosition = document.documentElement.scrollTop
          }
        },


    },

    components: {
        BarList, BarGrid, CustomerForm
    },

    mounted() {
      this.scroll()
    },

    beforeDestroy() {
      window.onscroll = null
      this.$modalForm(false)
    },

    created () {
      this.showForm = false
      this.loadData()
    },

    destroyed () {
      window.onscroll = null
      this.$modalForm(false)
      console.log('destroyed fv cliente list')
    },


}

</script>

<template>
    <div id="grid">
        <div id="list">

            <bar-list
                :refresh-button="true"
                :new-button="true"
                :pdf-button="false"
                :xls-button="true"
                single-entity="Cliente"
                plural-entity="Clientes"
                :moreActions="moreActionsBarList"
                @action="handleAction"
                @search="search"
                @new="incluirPart"
                @refresh="loadData"
                title-search="Pesquise pelo nome, nome fantasia, código, cnpj ou cpf">
            </bar-list>

            <div class="default-container nb-margin-top">
                <alert v-if="partList.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="part in partList" v-bind:key="part.codpart">
                    <div class="box">
                        <div class="row">
                            <div class="col-md-9 col-10">
                                <span class="lbl-title-produto" style="cursor: pointer" @click="handlePainel(part.codpart)">{{ part.nome }}</span>
                                <span class="data-list-sm">{{ part.cnpjcpf | formatCNPJCPF }}</span>
                                <span v-if="part.stpart=='I'" class="badge badge-yellow">{{ part.stpart | getTextOption(metadata.part.stpart) }}</span>
                                <div class="w-100"></div>
                                <span v-if="part.fone1" class="data-list-sm pr-3"><i class="fa fa-phone pr-2" aria-hidden="true"></i>{{ part.fone1 | formatFone }}</span>
                                <span v-if="part.fone2" class="data-list-sm pr-3"><i class="fa fa-phone pr-2" aria-hidden="true"></i>{{ part.fone2 | formatFone }}</span>
                                <span v-if="part.fone3" class="data-list-sm pr-3"><i class="fa fa-phone pr-2" aria-hidden="true"></i>{{ part.fone3 | formatFone }}</span>
                                <span v-if="part.email" class="data-list-sm pr-3"><i class="fa fa-envelope pr-2" aria-hidden="true"></i> {{ part.email }}</span>
                            </div>
                            <div class="col-md-3 col-2">
                                <bar-grid
                                    :options="{barDefault: true, btnView: false, btnEdit: true}"
                                    :moreActions="[]"
                                    @edit="editPart(part.codpart)">
                                </bar-grid>
                            </div>
                            <div class="col-md-6 col-6">
                                <span class="data-list-sm w-100">{{ part.fantasia }}</span>
                                <span v-if="part.nomemun" class="data-list-sm pr-3"><i class="fa fa-location-arrow pr-2" aria-hidden="true"></i> {{ part.nomemun }} {{ part.uf }}</span>
                            </div>
                            <div v-if="controleLimiteCredito" class="col-md-3 col-3">
                                <div class="w-100">
                                    <label class="lbl-list">{{ metadata.part.stcred.label }}</label>
                                    <span class="data-list-sm">{{ part.stcred | getTextOption(metadata.part.stcred) }}</span>
                                </div>
                                <div class="w-100">
                                    <label class="lbl-list">{{ metadata.part.limcred.label }}</label>
                                    <span class="data-list-sm">{{ part.limcred | formatValue(2) }}</span>
                                </div>
                            </div>
                            <div class="col-md-3 col-3">
                                <label v-if="part.data_ultima_compra" class="lbl-list">Última Compra Em</label>
                                <span v-if="part.data_ultima_compra" class="data-list-sm">{{ part.data_ultima_compra | formatData }}</span>
                                <label v-if="part.total_pedidos_aberto" class="lbl-list">Pedidos Abertos</label>
                                <span v-if="part.total_pedidos_aberto"  class="data-list-sm">{{ part.total_pedidos_aberto | formatValue(2) }}</span>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="nb-modal-scrollable" v-if="showForm">
            <div class="container nb-modal-scrollable-container" style="width: 800px; max-width: 100%">
                <div class="nb-modal-scrollable-body">
                    <customer-form :crud="crud" :index="codpart"  :forcaVendas="true" @closeform="closeForm"></customer-form>
                </div>
            </div>
        </div>

    </div>
</template>


<style>

</style>



// WEBPACK FOOTER //
// src/forms-fv/fv-cliente-list.vue